import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidator {
  static widgetCheckboxLimit(args: number[]): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      let checked = 0;
      Object.keys(group.controls).forEach(key => {
        if (group.get(key).value === true) {
          checked++;
        }
      });
      if (args?.length > 0 && checked < args[0]) {
        return {widgetCheckboxLimit: 'invalid'};
      } else {
        return null;
      }
    };
  }

  static widgetDataRetentionAndDeletionCheckboxLimit(minChecked: number, controlsName: string[]): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      let checked = 0;
      Object.keys(group.controls).forEach(key => {
        if (controlsName?.includes(key) && group.get(key).value === true) {
          checked++;
        }
      });
      if (checked < minChecked) {
        return {widgetCheckboxLimit: 'invalid'};
      } else {
        return null;
      }
    };
  }
}
